import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "bullets", "position" , "content"];
  openClass = 'lg-hotspot--selected';

  connect() {

    let allLabels = document.querySelectorAll('.lg-hotspot__label');
    allLabels.forEach((label) => {
      this.positionLabel(label);
    })
  }

  show(event) {
    event.preventDefault();
    const parent = event.currentTarget.parentElement;
    const isOpen = parent.classList.contains(this.openClass);

    for (let element of this.bulletsTargets) {
      element.classList.remove(this.openClass);
    }

    let label = event.currentTarget.parentElement.querySelector('.lg-hotspot__label');
    if (!isOpen) {
      event.currentTarget.parentElement.classList.add(this.openClass);
      const clone = label.cloneNode(true);
      this.contentTarget.innerHTML = '';
      this.contentTarget.appendChild(clone);

      this.positionLabel(label);
    }
  }

  positionLabel(label) {
    const screenSize = document.body.clientWidth;
    label.style.right = 'auto';
    const size = label.getBoundingClientRect();
    if (size.left + size.width >= screenSize) {
      label.style.right = '0';
    } else {
      label.style.right = 'auto';
    }
  }

  hide(event) {
    event.preventDefault();

    for (let element of this.bulletsTargets) {
      this.contentTarget.innerHTML = '';
      element.classList.remove(this.openClass);
    }
  }
}

